"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegerInput = IntegerInput;

var _numberInput = require("./number-input");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Export `IntegerInput` component.
 */
function IntegerInput(props) {
  return /*#__PURE__*/_react["default"].createElement(_numberInput.NumberInput, _extends({}, props, {
    valueType: 'number'
  }));
}